import { SET_USERS_SEARCH_AND_SELECT } from './../const/index'

const initialState = { value: '', triggerSelection: false };

export const usersReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_USERS_SEARCH_AND_SELECT:
            return { ...state, value: action.payload, triggerSelection: true }; 
        default:
            return state;
    }
};
